// src/app/subscription/page.jsx
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Package } from "lucide-react";

export default function SubscriptionPage() {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
              <Package className="h-8 w-8 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Subscription Boxes
          </h1>
          <p className="text-xl text-muted-foreground">
            Curated seasonal delights delivered monthly
          </p>
        </div>
        <Card className="backdrop-blur-sm bg-card/70 border-2 border-border">
          <CardHeader>
            <CardTitle>Monthly Artisan Boxes</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground">
              Subscribe to receive handpicked artisan products every month. Customization options coming soon!
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
